import React from 'react';
import PropTypes from 'prop-types';

import Follower from './follower-detail';
import SectionHeader from '../../shared/section-header';

import { followers } from './index.module.scss';

function FollowingList({ followingList }) {
  return (
    <>
      <SectionHeader
        headingLeft={`${followingList.length} following`}
        headingRight=""
        colWith={12}
      />
      <div className={followers}>
        {followingList.map(follower => (
          <Follower follower={follower} key={follower.id} />
        ))}
      </div>
    </>
  );
}

FollowingList.defaultProps = {
  followingList: [],
};

FollowingList.propTypes = {
  followingList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullname: PropTypes.string.isRequired,
      bio: PropTypes.string,
      imgUrl: PropTypes.string,
      followers: PropTypes.array.isRequired,
    }).isRequired
  ).isRequired,
};

export default FollowingList;
